export default "__VITE_ASSET__BUwJN7WT__"